import Vue from 'vue'
import Router from 'vue-router'
import Work from './views/Work'
import Information from './views/Information'
import Profile from './views/Profile'
import Projects from './views/Projects'
import Auth from './views/Auth'

import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {selector: to.hash};
        } else {
            return {x: 0, y: 0};
        }
    },
  routes: [
    {
      path: '*', redirect: '/work'
    },
    {
      path: '/work',
      name: 'work',
      component: Work
    },
    {
      path: '/information',
      name: 'information',
      component: Information
    },
    {
      path: '/profile/:project_id?',
      name: 'profile',
      component: Profile
    },
    {
      path: '/projects/:project_id?',
      name: 'projects',
      component: Projects
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (from.name) {
    store.commit('SETRANDOMBACKGROUNDCOLOR')
  }
  next()
})

export default router
